module.exports = __webpack_public_path__ + "static/media/ic-navigation-left.043be889.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pagination/ic-navigation-left.svg
// module id = 1218
// module chunks = 0